import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=391a7cca&scoped=true"
import script from "./Appeal.vue?vue&type=script&lang=js"
export * from "./Appeal.vue?vue&type=script&lang=js"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=391a7cca&prod&lang=scss&scoped=true"
import style1 from "./Appeal.vue?vue&type=style&index=1&id=391a7cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a7cca",
  null
  
)

export default component.exports